import React from "react";
import styled from "styled-components";
import { GlossyThemeProvider } from "@glossy";
import { prettyScrollbars } from "@glossy/mixins";
import { Spacing } from "@glossy/spacings";
import { background, content } from "@glossy/theme";
import Container from "@ui-kit/modal/container";

interface IProps {
  // Embeded elements
  children?: React.ReactNode;
  onClose?: () => void;
  // Force width
  width?: number | string;
  padding?: number | string;
  fullWidth?: boolean;
  height?: number;
}

const MAX_WIDTH: number = 757;
const MIN_MARGIN: number = 24;

const Root = styled.div<{ fullWidth?: boolean; height?: number }>`
  display: flex;
  flex-direction: column;
  background-color: ${background};
  color: ${content};
  min-width: 360px;
  max-height: ${({ height }) =>
    height ? `${height}px` : `calc(100vh - ${Spacing.Large})`};
  max-width: ${({ fullWidth }) =>
    fullWidth ? "max-content" : `${MAX_WIDTH}px`};
  ${prettyScrollbars};

  @media (max-width: ${MAX_WIDTH + MIN_MARGIN}px) {
    max-width: calc(100vw - ${MIN_MARGIN}px);
  }
`;

const UiKitModalRoot = ({
  children,
  onClose,
  width = 650,
  padding = 0,
  fullWidth,
  height,
}: IProps) => (
  <Container onCancel={onClose} isOpen>
    <GlossyThemeProvider name="surface">
      <Root fullWidth={fullWidth} height={height} style={{ width, padding }}>
        {children}
      </Root>
    </GlossyThemeProvider>
  </Container>
);

export default UiKitModalRoot;
